module.exports = __webpack_public_path__ + "static/media/jm.0e586ac8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jm.svg
// module id = 2124
// module chunks = 0